<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="table.where" label-width="77px" 
             :inline="true"  @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
        <el-row :gutter="15">
            <el-form-item label="地区:">
                <el-cascader v-model="table.where.city" :options="cityData.cityData" clearable popper-class="ele-pop-wrap-higher"/>
            </el-form-item>
          <el-form-item label="联系人:">
            <el-input placeholder="请输入姓名" v-model="table.where.contacts" clearable/>
          </el-form-item>
          <el-form-item label="联系方式:">
            <el-input placeholder="请输入电话" v-model="table.where.phone" clearable/>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询
              </el-button>
              <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
            </el-form-item>
        </el-row>
      </el-form>
      <!-- 操作按钮 -->
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small" v-if="permission.includes('sys:store:add')">添加
        </el-button>
        <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small" v-if="permission.includes('sys:store:dall')">批量删除
        </el-button>
      </div>
      <!-- 数据表格 -->
      <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)" highlight-current-row>
        <template slot-scope="{index}">
          <el-table-column type="selection" width="45" align="center" fixed="left"/>
          <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left" show-overflow-tooltip/>
                  
          <el-table-column prop="store_name" label="店铺名称" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="number" label="编号" sortable="custom" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="contacts" label="联系人" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="phone" label="手机号" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="region" label="地区" show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="goods_type_title" label="商品类型"  show-overflow-tooltip min-width="120">
              <template slot-scope="{row}">
                  <el-tag v-for="(item,index) in row.goods_type_title" :key="index">{{item.title}}</el-tag>
              </template>
          </el-table-column>
                                
          <!-- <el-table-column prop="account" label="账号" sortable="custom" show-overflow-tooltip min-width="120"/> -->
                                
          <!-- <el-table-column prop="password" label="密码" sortable="custom" show-overflow-tooltip min-width="120"/> -->
                                
          <!-- <el-table-column prop="status" label="状态"  show-overflow-tooltip min-width="120"/> -->
                  
          <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
            <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
          </el-table-column>
          <!-- <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
            <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
          </el-table-column> -->
          <el-table-column label="操作" width="130px" align="center" :resizable="false"  fixed="right">
            <template slot-scope="{row}">
              <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false" v-if="permission.includes('sys:store:edit')">修改</el-link>
              <el-popconfirm title="确定要删除此商家吗？" @confirm="remove(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false" v-if="permission.includes('sys:store:delete')">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <!-- 编辑弹窗 -->
    <el-dialog :title="editForm.id?'修改商家':'新增商家'" :visible.sync="showEdit" width="450px"
               @closed="editForm={}" :destroy-on-close="true" :lock-scroll="false">
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="100px">
        <el-form-item label="商品类型：" prop="goods_type">
            <el-select v-model="editForm.goods_type" multiple placeholder="请选择商品类型">
                <el-option
                  v-for="item in category_info"
                  :key="item.value"
                  :label="item.title"
                  :value="item.id">
                </el-option>
              </el-select>
        </el-form-item>
        <el-form-item label="店铺名称：" prop="store_name">
            <el-input v-model="editForm.store_name" placeholder="请输入店铺名称" clearable/>
        </el-form-item>
                                                  
        <el-form-item label="联系人：" prop="contacts">
             <el-col :span="12">
            <el-input  size="small" v-model="editForm.contacts" placeholder="请输入姓名" clearable/>
             </el-col>
             <el-col :span="12">
            <el-input-number  size="small" v-model="editForm.phone" controls-position="right" :min="0"
                              placeholder="请输入手机号" class="ele-fluid ele-text-left"/>
                              </el-col>
        </el-form-item>
                                                      
        <el-form-item label="地区：" prop="region">
            <el-cascader v-model="city" :options="cityData.cityData" clearable popper-class="ele-pop-wrap-higher"/>
        </el-form-item>
                                                      
        <el-form-item label="账号：" prop="account">
            <el-input v-model="editForm.account" placeholder="请输入账号" clearable/>
        </el-form-item>
                                                  
        <el-form-item label="密码：" prop="password">
            <el-input v-model="editForm.password" placeholder="请输入密码" clearable/>
        </el-form-item>
                                                  
       <!-- <el-form-item label="状态：" prop="status">
            <el-input-number v-model="editForm.status" controls-position="right" :min="0"
                              placeholder="请输入状态" class="ele-fluid ele-text-left"/>
        </el-form-item> -->
                              
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit=false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import cityData from '@/utils/cityData'
export default {
  name: "SysStore",
  data() {
    return {
        city:'',
        category_info:[],
        cityData: cityData,  // 省市区数据
      table: {url: '/store/index', where: {}},  // 表格配置
      choose: [],  // 表格选中数据
      showEdit: false,  // 是否显示表单弹窗
      editForm: {},  // 表单数据
      editRules: {  // 表单验证规则
                        
        store_name: [
          {required: true, message: '请输入商家名称', trigger: 'blur'}
        ],
                                    
        contacts: [
          {required: true, message: '请输入联系人', trigger: 'blur'}
        ],
                          
        phone: [
          {required: true, message: '请输入手机号', trigger: 'blur'}
        ],
                                    
        region: [
          {required: true, message: '请输入地区', trigger: 'blur'}
        ],
                          
        goods_type: [
          {required: true, message: '请输入商品类型', trigger: 'blur'}
        ],
                                    
        account: [
          {required: true, message: '请输入账号', trigger: 'blur'}
        ],
                                    
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'}
        ],
                          
              
      },
    }
  },
computed: {
    ...mapGetters(["permission"]),
},
  mounted() {
      this.category();
  },
  methods: {
    /**
      * 查询分类列表
      */
    category(){
        this.$http.get('/storegoodscategory/categoryInfo').then(res => {
          if (res.data.code === 0) {
            this.category_info = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(e => {
          this.$message.error(e.message);
        });
    },
      
    /**
     * 显示编辑
     */
    edit(row) {
      this.editForm = JSON.parse(JSON.stringify(row))
      var temp_goods_type = row.goods_type.split(',');
      for(var i = 0;i<temp_goods_type.length;i++){
          temp_goods_type[i] = parseInt(temp_goods_type[i])
      }
      this.editForm.goods_type = temp_goods_type;
      this.showEdit = true;
      // 取值赋予城市组件
      this.city = row.city;
    },
    /**
     * 保存编辑
     */
    save() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({lock: true});
          this.editForm = Object.assign({}, this.editForm, {
            city: this.city
          });
          var city = this.editForm.city;
          var city_data = '';
          for(var i =0;i<cityData.cityData.length;i++){
              if(city[0] == cityData.cityData[i].value){
                  city_data = cityData.cityData[i].label
                  for(var j =0;j<cityData.cityData[i].children.length;j++){
                      if(city[1] == cityData.cityData[i].children[j].value){
                          city_data = city_data+'-'+cityData.cityData[i].children[j].label
                          for(var k =0;k<cityData.cityData[i].children[j].children.length;k++){
                              if(city[2] == cityData.cityData[i].children[j].children[k].value){
                                  city_data = city_data+'-'+cityData.cityData[i].children[j].children[k].label
                              }
                          }
                      }
                  }
              }
          }
          this.editForm.region = city_data;
          this.editForm.goods_type = this.editForm.goods_type.join(',');
          this.$http.post('/store/edit', this.editForm).then(res => {
            loading.close();
            if (res.data.code === 0) {
              this.showEdit = false;
              this.$message({type: 'success', message: res.data.msg});
              this.$refs.table.reload();
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(e => {
            loading.close();
            this.$message.error(e.message);
          });
        } else {
          return false;
        }
      });
    },
    /**
     * 刪除(批量刪除)
     */
    remove(row) {
      console.log(row)
      if (!row) {  // 批量删除
        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
        let ids = this.choose.map(d => d.id);
        this.$confirm('确定要删除选中的商家吗?', '提示', {type: 'warning'}).then(() => {
          const loading = this.$loading({lock: true});
          this.$http.post('/store/delete', {id: ids}).then(res => {
            loading.close();
            if (res.data.code === 0) {
              this.$message({type: 'success', message: res.data.msg});
              this.$refs.table.reload();
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(e => {
            loading.close();
            this.$message.error(e.message);
          });
        }).catch(() => 0);
      } else {  // 单个删除
        const loading = this.$loading({lock: true});
        this.$http.post('/store/delete', {id:row.id}).then(res => {
          loading.close();
          if (res.data.code === 0) {
            this.$message({type: 'success', message: res.data.msg});
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(e => {
          loading.close();
          this.$message.error(e.message);
        });
      }
    },
                                        }
}
</script>

<style scoped>
.ele-block >>> .el-upload, .ele-block >>> .el-upload-dragger {
  width: 100%;
}
</style>